import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

const DraggableTire = ({ tire, position, isOverlay = false }) => {
   
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: position.id,
        data: {
            tire,
            position,
            type: 'tire'
        }
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
        zIndex: isOverlay ? 1000 : 1,
        pointerEvents: isOverlay ? 'none' : 'auto'
    };

    if (!tire) {
        return (
            <div
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className="w-full min-h-16 p-2 shadow-lg bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-500 cursor-grab active:cursor-grabbing"
            >
                {position.label}
            </div>
        );
    }

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className={`w-full min-h-16 p-2 shadow-lg bg-white border border-gray-200 hover:shadow-md transition-shadow cursor-grab active:cursor-grabbing ${
                isDragging ? 'opacity-50' : ''
            }`}
        >
            <div className="grid grid-cols-2 gap-2 w-full text-xs">
                <div className="font-medium ">{tire.brand}</div>
                <div className="font-medium text-end">{tire.model}</div>
                <div className="font-medium ">{tire.size}</div>
                <div className="text-end">{tire.tin}</div>
            </div>
        </div>
    );
};

export default DraggableTire; 